import * as React from 'react';
import { useIntl } from 'react-intl';
import { styled } from 'stitches.config';

import Typography from '@/components/sushi/Typography';

type SitemapCategoryProps = {
  title: string;
  locale: string;
  links: {
    name: string;
    href: string;
    supportedLocales: string[];
  }[];
  variant?: 'row' | 'col';
};

export const SitemapCategory = ({ title, locale, links, variant }: SitemapCategoryProps) => {
  const { formatMessage } = useIntl();

  const formatExternalHref = (href: string) => {
    return href.startsWith('http')
      ? href
      : `${process.env.NEXT_PUBLIC_PUBLIC_PATH}/${locale}${href}`;
  };

  return (
    <SitemapCategoryContainer variant={variant}>
      <Typography variant="bodyL" color="primaryAlt" className="mr-4" style={{ maxWidth: 200 }}>
        {formatMessage({ id: `sitemap.${title}.title` })}
      </Typography>

      <div className="flex flex-col">
        {links
          .filter((link) => link.supportedLocales.includes(locale))
          .map(({ name, href }) =>
            <Typography as="a" href={formatExternalHref(href)} variant="bodyM" color="primaryAlt">
              {formatMessage({ id: `sitemap.${title}.${name}` })}
            </Typography>
          )}
      </div>
    </SitemapCategoryContainer>
  );
};

const SitemapCategoryContainer = styled('div', {
  gap: '16px',
  display: 'flex',
  variants: {
    variant: {
      row: {
        flexDirection: 'row',
        '@media (max-width: 900px)': {
          flexDirection: 'column',
        }
      },
      col: {
        flexDirection: 'column',
      },
    },
  },
  defaultVariants: {
    variant: 'row',
  },
});
